import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import Button from './Button';
import DisplayDate from './DisplayDate';
import StatusIcon from './StatusIcon';

// ICONS
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';

// TYPES
import { StaffFetchChecklist } from '../api/models/staff-fetch-checklist';

interface ProfileChecklistsTypes {
	checklists?: Array<StaffFetchChecklist>;
	defaultMaxItems?: number;
	isPastProfile?: boolean;
}

const ProfileChecklists: React.FC<ProfileChecklistsTypes> = ({ checklists, defaultMaxItems, isPastProfile }) => {
	const [maxChecklistsItem, setMaxChecklistsItem] = React.useState<number>(defaultMaxItems || 5);

	return (
		<>
			{checklists && checklists.length > 0 && (
				<section className="info-section">
					<div className="section-header">
						<h2 className="header-name color-dark">Checklists</h2>
					</div>

					{checklists.slice(0, maxChecklistsItem).map((item, index) => {
						return (
							<div key={index} className="row-container">
								<div className="row detail-row">
									<div className="col-auto pdl-0 pdr-0">
										<StatusIcon statusType={item.status || 'Error'} />
									</div>

									<div className="col-md-auto full-width">
										<div className="row detail-info">
											<div className="col-lg-3 detail-name">{item.purpose}</div>

											<div className={`col-lg-2 detail-label ${item.status?.toLowerCase()}`}>
												{item.checklistStatus}
											</div>

											<div className="col-lg-4 detail-status">
												{item.updated ? (
													<>
														<div className="title">Last updated</div>

														<time className="name">
															<DisplayDate>{item.updated}</DisplayDate>
														</time>
													</>
												) : null}
											</div>

											<div className="col-lg-3 detail-status">
												<div className="title">By</div>

												<div className="status">{item.creator}</div>
											</div>
										</div>
									</div>

									<div className="col-auto pdr-0 link-group">
										{item.status === 'Success' || isPastProfile ? (
											<Link className="btn-text pdr-0" to={`/safety-checklists/${item.id}`}>
												View
											</Link>
										) : (
											<Link className="btn-text pdr-0" to={`/safety-checklists/${item.id}`}>
												Review
											</Link>
										)}
									</div>
								</div>
							</div>
						);
					})}

					{maxChecklistsItem < checklists.length && (
						<Button
							className="btn-secondary btn-show-more"
							onClick={() => setMaxChecklistsItem(checklists.length)}
							buttonIcon={<PlusIcon className="link-icon" />}
						>
							Show {checklists.length - maxChecklistsItem} more
						</Button>
					)}
				</section>
			)}
		</>
	);
};

export default ProfileChecklists;
